import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    zhikeTong_token: localStorage.getItem('zhikeTong_token') ? localStorage.getItem('zhikeTong_token') : '',
    zhikeTong_userName: localStorage.getItem('zhikeTong_userName') ? localStorage.getItem('zhikeTong_userName') : '',
    zhikeTong_userPhone: localStorage.getItem('zhikeTong_userPhone') ? localStorage.getItem('zhikeTong_userPhone') : '',
    zhikeTong_userPost: localStorage.getItem('zhikeTong_userPost') ? localStorage.getItem('zhikeTong_userPost') : '',
    zhikeTong_authRoter: localStorage.getItem('zhikeTong_authRoter') ? localStorage.getItem('zhikeTong_authRoter') : '',
    zhikeTong_userId: localStorage.getItem('zhikeTong_userId') ? localStorage.getItem('zhikeTong_userId') : '',
  },
  mutations: {
    changeuser(state, user) {
      console.log(user);
      state.zhikeTong_token = user.user.userAes;
      state.zhikeTong_userName = user.user.auName;
       state.zhikeTong_userId = user.user.auId;
      state.zhikeTong_userPhone = user.user.auAccount;
      state.zhikeTong_userPost = user.user.auPost;
      state.zhikeTong_authRoter = JSON.stringify( user.user.ajRoleAuthList)
      localStorage.setItem('zhikeTong_token', user.user.userAes);
        localStorage.setItem('zhikeTong_userId', user.user.auId);
      localStorage.setItem('zhikeTong_userName', user.user.auName);
      localStorage.setItem('zhikeTong_userPhone', user.user.auAccount);
      localStorage.setItem('zhikeTong_userPost', user.user.auPost);
      localStorage.setItem('zhikeTong_authRoter', JSON.stringify( user.user.ajRoleAuthList));
    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
